import { AziendeStoreService } from '../../Admin/_service/aziende-store.service';
import { PersonaleStoreService } from '../../Admin/_service/personale-store.service';
import { DatePipe } from '@angular/common';
import { InterventoComponent } from '../intervento/intervento.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FiltriInterventi } from '../Models/FiltriInterventi';
import { ApiRestService } from '../_services/api-rest.service';
import { InterventiStoreService } from '../_services/interventi-store.service';
import {Component, Input, OnInit, Output, EventEmitter, Inject, Optional, AfterViewInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServerPaginationService } from 'src/app/shared/_services/server-pagination.service';
import { Intervento } from '../Models/Intervento';
import { Subscription } from 'rxjs';
import { ClassicType } from 'src/app/shared/models/ClassicType';
import { Progetto } from 'src/app/Progetti/Models/Progetto';
import { Persona } from '../../Admin/models/persona';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { RicercaPaginazione } from 'src/app/Admin/models/sendpersonale';
import { Azienda } from 'src/app/Admin/models/Azienda';
import {Permission} from "../../Login/_guards/Permission";
import {AuthenticationService} from "../../Login/_services/authentication.service";
import {environment} from "../../../environments/environment"

@Component({
  selector: 'app-lista-interventi-offerta',
  templateUrl: './lista-interventi-offerta.component.html',
})
export class ListaInterventiOffertaComponent implements AfterViewInit {
  subscriptions: Subscription = new Subscription();
  collectionSize: number = 0;
  @Input() Interventi: Intervento[] = null;
  @Input() Offerta: Progetto = null;
  @Output() OffertaChange = new EventEmitter();
  @Input() Cliente: boolean = false;
  @Input() Padre: Intervento = undefined;
  @Input() hasHeader: Boolean = true;
  @Input() hasFilter: Boolean = false;
  @Input() hasAddButton: Boolean = false;
  @Input() ModificheAbilitate: boolean = true;
  @Input() EditInModal: boolean=true;
  @Input() filtri: FiltriInterventi = null;
  @Output() AddClick = new EventEmitter();
  @Output() EditClick = new EventEmitter();
  @Output() DeleteClick = new EventEmitter();
  @Output() onChange = new EventEmitter();
  @Output() onRefresh = new EventEmitter();
  clienteSelezionato: Azienda;
  statiIntervento: ClassicType[] = [];
  /**************************************
    Variabili paginazione
    **************************************/
  page = 1;
  pageSize = 50;
  pagesizeserver = 4 // pagine da precaricare da lserver
  newpagegenerated = 1; // pagina per cui è stata fatta la richiesta al server
  managers: Persona[] = [];
  managerselezionati: Persona[] = [];
  utentidropdownSettings: IDropdownSettings = {
    singleSelection: true,
    closeDropDownOnSelection: true,
    idField: 'id',
    textField: 'fullName',
    searchPlaceholderText: "inserire almeno 3 caratteri",
    allowSearchFilter: true,
    allowRemoteDataSearch: true,
  };
  environment = environment;
  constructor(
    @Optional() @Inject('Offerta') public Offert: Progetto,
    @Optional() @Inject('hasAddButton') public HasAddButton: boolean,
    private paginationService: ServerPaginationService,
    private InterventiStore: InterventiStoreService,
    private apirestservice: ApiRestService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private datepipe: DatePipe,
    private personaleStore: PersonaleStoreService,
    private aziendeStore: AziendeStoreService,
    public permission: Permission,
    public authSvc: AuthenticationService,
    private apiRestService: ApiRestService,
  ) {
    if(Offert)
      this.Offerta = Offert;
    if(HasAddButton)
      this.hasAddButton = HasAddButton;
  }

  ngAfterViewInit() {
    if (this.hasFilter) {
      this.filtri = new FiltriInterventi();
      const today = new Date();
      this.filtri.inizio = this.datepipe.transform(new Date(today.getFullYear(), today.getMonth(), 1), 'yyyy-MM-dd');
      this.filtri.fine = this.datepipe.transform(new Date(today.getFullYear(), today.getMonth() + 1, 0), 'yyyy-MM-dd');
      this.subscriptions.add(this.personaleStore.$listaPersonale.subscribe((items) => {
        if (items && items !== null)
          this.managers = items.data;
      }));
    }
    if (this.Cliente) {
      this.subscriptions.add(this.aziendeStore.$selectedAzienda.subscribe((item) => {
        this.clienteSelezionato = item;
        this.refreshTable(1);
      }));
    }
    this.InterventiStore.updateIsModal(this.EditInModal);
    this.InterventiStore.getStatiIntervento();
    if(!this.Interventi){
      this.refreshTable(1);
      this.InterventiStore.updateOffertaSelezionata(this.Offerta);
      this.subscriptions.add(this.InterventiStore.$statiIntervento.subscribe(x => this.statiIntervento = x));
      this.subscriptions.add(this.InterventiStore.$interventi.subscribe(x => {
          this.collectionSize = x?.total ?? 0;
          this.Interventi = x?.data ?? [];
          if(this.Offerta){
          this.Offerta.SommaImportiFase = this.Interventi.reduce((acc, intervento) => acc + (parseFloat(intervento.importo?.toString() ?? '0') ?? 0), 0);
          this.Offerta['DiffImportiFase'] = parseFloat(this.Offerta['valAccettato']?.toString() ??'0' ) - this.Offerta.SommaImportiFase;

          this.Offerta['Interventi'] = x?.data ?? [];
          }
      }));
    }
  }
  add() {
    if (this.ModificheAbilitate) {
      const item: Intervento = new Intervento();
      if(this.Padre) {
        item.padre = this.Padre.id;
        item.progetto = this.Padre.progetto;
        item.tipiObject = this.Padre.tipiObject;
      }
      // this.InterventiStore.updateInterventoSelezionato(item);
      this.InterventiStore.updateOffertaSelezionata(this.Offerta);
      this.InterventiStore.updateEditable(false);
      this.InterventiStore.updateShowAddForm(true);
      this.openInterventoForm(item);
      this.AddClick.emit();
    }
  }
  edit(item: Intervento) {
    if (this.ModificheAbilitate && (this.permission.isPermitted('gestione-fasi') || this.permission.hasOperativeRole('RF') || this.permission.hasOperativeRole('PM') || this.permission.hasOperativeRole('PF'))) {
      // this.InterventiStore.updateInterventoSelezionato(item);
      this.InterventiStore.updateEditable(true);
      this.InterventiStore.updateShowAddForm(false);
      this.openInterventoForm(item);
      this.EditClick.emit(item);
    }
  }
  delete(item: Intervento) {
    if (this.ModificheAbilitate && confirm("Sei sicuro di voler eliminare questo elemento?")) {
      this.apirestservice.softDeleteinterventi(item).subscribe(
        () => this.refreshTable(this.newpagegenerated)
      );
      this.DeleteClick.emit(item);
    }
  }
  renew(item: Intervento) {
    if (this.ModificheAbilitate) { }
  }
  getPage(page: number) {
    this.page = this.paginationService.paginadellalista(page, this.pagesizeserver);
    const pagetosend = this.paginationService.getPage(page, this.newpagegenerated, this.pagesizeserver);
    if ((pagetosend - 1) % this.pagesizeserver === 0) {
      this.newpagegenerated = page;
      this.refreshTable(pagetosend);
    }
  }
  refreshTable(page: number) {
    var request: FiltriInterventi | Progetto | Azienda;
    var tipo: 'Filtro'|'Progetto'|'Cliente';
    if (this.hasFilter && this.filtri ) {
      this.filtri.periodo = true;
      this.filtri.manager = this.managerselezionati?.length > 0 ? this.managerselezionati[0]?.id : undefined;
      request = this.filtri;
      tipo = 'Filtro'
    } else if (this.Cliente &&  this.clienteSelezionato && !isNaN(this.clienteSelezionato.id)) {
      request = this.clienteSelezionato;
      tipo = 'Cliente';
    } else if (this.Offerta  && !isNaN(this.Offerta.id)) {
      request = this.Offerta;
      tipo = 'Progetto';
    } else if (!this.Offerta && !this.Cliente) {
      request = new FiltriInterventi((page - 1) / this.pagesizeserver + 1, this.pagesizeserver * this.pageSize);
      tipo = 'Filtro';
    } else {
      request = undefined;
      tipo = undefined
      this.InterventiStore.svuotaListaInterventi();
    }
    if(tipo && request)
      this.InterventiStore.getInterventi(request,tipo);
    this.onRefresh.emit();
  }
  openInterventoForm(item: Intervento) {
    console.log("Intervento:", item);
    if(item?.id)
      this.apiRestService.getInfoIntervento(item).subscribe(data => {
        if (this.EditInModal) {
          const modal = this.modalService.open(InterventoComponent, {
            centered: true,
            container: '#main-wrapper',
            backdrop: 'static',
            size: 'xl',
          });
          (<InterventoComponent>modal.componentInstance).InterventoSelezionato = data.data;
          (<InterventoComponent>modal.componentInstance).Refresh.subscribe(data=> {this.refreshTable(this.newpagegenerated)});
        } else {
          this.router.navigate([this.route.snapshot.queryParams[' interventi/intervento '] || 'interventi/intervento',]);
        }
      });
    else {
      if (this.EditInModal) {
        const modal = this.modalService.open(InterventoComponent, {
          centered: true,
          container: '#main-wrapper',
          backdrop: 'static',
          size: 'xl',
        });
        (<InterventoComponent>modal.componentInstance).InterventoSelezionato = item;
        (<InterventoComponent>modal.componentInstance).Refresh.subscribe(data=> {this.refreshTable(this.newpagegenerated)});
      } else {
        this.router.navigate([this.route.snapshot.queryParams[' interventi/intervento '] || 'interventi/intervento',]);
      }
    }

  }
  filtroResponsabile(item: string) {
    if (item.length >= 3) {
      this.personaleStore.getListaPersonale(new RicercaPaginazione(item, 0, 1));
    }
  }
}
